import { AnimatePresence } from "framer-motion";
import { useCallbackForm } from "./CallbackForm/useCallbackForm";
import CallbackSuccess from "./CallbackForm/CallbackSuccess";
import CallbackFields from "./CallbackForm/CallbackFields";

export default function CallbackForm() {
    const { form, errors, status, submitError, setField, onSubmit, reset } =
        useCallbackForm();

    return (
        <AnimatePresence mode="wait">
            {status === "success" ? (
                <CallbackSuccess onReset={reset} />
            ) : (
                <CallbackFields
                    form={form}
                    errors={errors}
                    status={status}
                    submitError={submitError}
                    setField={setField}
                    onSubmit={onSubmit}
                />
            )}
        </AnimatePresence>
    );
}
